import type { CreateNolaPfContestExtraAnswer, NolaPfContestExtraFieldItem } from "@/lib/models/nolaPfContest";

/** key が空の項目は入力・送信の対象にしない。 */
export function visibleExtraFieldItems(
  fields: NolaPfContestExtraFieldItem[] | undefined
): NolaPfContestExtraFieldItem[] {
  return (fields ?? []).filter((field) => field.key.length > 0);
}

export function extraFieldMaxLength(field: NolaPfContestExtraFieldItem): number | undefined {
  return typeof field.maxLength === "number" ? field.maxLength : undefined;
}

/** 必須の未入力と最大文字数の超過を弾く。任意項目の空文字は可。 */
export function areExtraAnswersComplete(
  fields: NolaPfContestExtraFieldItem[] | undefined,
  answers: Record<string, string> | undefined
): boolean {
  return visibleExtraFieldItems(fields).every((field) => {
    const value = answers?.[field.key] ?? "";
    if (field.required && value.length === 0) return false;
    const maxLength = extraFieldMaxLength(field);
    return maxLength === undefined || value.length <= maxLength;
  });
}

/** 定義された追加項目が無いときは extraAnswers を送らない。 */
export function toContestExtraAnswers(
  fields: NolaPfContestExtraFieldItem[] | undefined,
  answers: Record<string, string> | undefined
): CreateNolaPfContestExtraAnswer[] | undefined {
  const visible = visibleExtraFieldItems(fields);
  if (visible.length === 0) return undefined;
  return visible.map((field) => ({
    key: field.key,
    value: answers?.[field.key] ?? "",
  }));
}
